<template>
  <div class="availabilities">
        <div>
            <div class="container">
                <div class="columns">
                    <div class="column is-3">
                        <app-sidebar></app-sidebar>
                        <onboarding></onboarding>
                    </div>
                    <div class="column is-9">
                        <div v-if="! currentOffice" class="section mt-7 mb-10">
                            <p class="is-aligned-center">{{ $t('no_office_selected') }}</p>
                        </div>
                        <div v-for="office in offices" :key="office.id" class="mt-7" v-if="currentOffice == office.id">
                            <div class="tabs">
                                <ul>
                                    <li v-for="date in dates" :class="{'is-active': date == currentDate}">
                                        <a @click.prevent="selectDate(date)">{{ date | momentFormat('YYYY-MM-DD', $t('date_selector_format')) }}</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <table class="table is-striped is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('morning_label') }}</th>
                                                <th class="has-text-right">{{ $t('available_label') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="! showEarlySlots">
                                                <td colspan="2" class="has-text-centered clickable" @click.prevent="toggleEarlySlots()">
                                                    <a href="#" class="is-size-7">{{ $t('show_early_slots') }}</a>
                                                </td>
                                            </tr>
                                            <tr v-for="slot in _.filter(timeSlots, (time, key) => { return key < 48 && (showEarlySlots ? true : key >= 32 || _.has(officeReservedAvailabilities, key)) })" style="overflow: hidden;">
                                                <td v-if="_.has(officeReservedAvailabilities, slot.key)">
                                                    <figure class="image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable" v-if="hasAvailabilityPictures(slot.key)" @click.prevent="showEmergency(slot.key)">
                                                        <img :src="getAvailabilityPicture(slot.key)" alt="Image Preview" style="max-height: 100%; max-width: 100%;">
                                                    </figure>
                                                    <button class="button is-info is-outline is-pulled-left mr-2" v-else @click.prevent="showEmergency(slot.key)">
                                                        <b-icon icon="clipboard-account"></b-icon>
                                                    </button>
                                                    <span class="data-title">
                                                        {{ slot.start }} - {{ slot.end }}
                                                        <span class="is-size-7 has-text-grey has-text-weight-light" v-text="getAvailabilityStatus(slot.key)"></span>
                                                    </span>
                                                    <span class="data-value" v-text="getPatientInfo(slot.key)"></span>
                                                </td>
                                                <td v-else>
                                                    <button class="button is-info is-outline is-pulled-left mr-2" disabled>
                                                        <b-icon icon="clipboard-account"></b-icon>
                                                    </button>
                                                    <span class="data-title">{{ slot.start }} - {{ slot.end }}</span>
                                                    <span class="data-value">—</span>
                                                </td>
                                                <td class="has-text-right">
                                                    <toggle-button
                                                        v-if="! isPastSlot(slot)"
                                                        @change="toggle(slot.key)"
                                                        :value="isTimeSlotActive(slot.key)"
                                                        :disabled="! doctor.isCertified || _.has(officeReservedAvailabilities, slot.key)"
                                                        :width="40"
                                                        :sync="true"
                                                        ></toggle-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="column">
                                    <table class="table is-striped is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('afternoon_label') }}</th>
                                                <th class="has-text-right">{{ $t('available_label') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="slot in _.filter(timeSlots, (time, key) => { return key >= 48 && (showLateSlots ? true : key < 80 || _.has(officeReservedAvailabilities, key)) })">
                                                <td v-if="_.has(officeReservedAvailabilities, slot.key)">
                                                    <figure class="image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable" v-if="hasAvailabilityPictures(slot.key)" @click.prevent="showEmergency(slot.key)">
                                                        <img :src="getAvailabilityPicture(slot.key)" alt="Image Preview" style="max-height: 100%; max-width: 100%;">
                                                    </figure>
                                                    <button class="button is-info is-outline is-pulled-left mr-2" @click.prevent="showEmergency(slot.key)" v-else>
                                                        <b-icon icon="clipboard-account"></b-icon>
                                                    </button>
                                                    <span class="data-title">
                                                        {{ slot.start }} - {{ slot.end }}
                                                        <span class="is-size-7 has-text-grey has-text-weight-light" v-text="getAvailabilityStatus(slot.key)"></span>
                                                    </span>
                                                    <span class="data-value" v-text="getPatientInfo(slot.key)"></span>
                                                </td>
                                                <td v-else>
                                                    <button class="button is-info is-outline is-pulled-left mr-2" disabled>
                                                        <b-icon icon="clipboard-account"></b-icon>
                                                    </button>
                                                    <span class="data-title">{{ slot.start }} - {{ slot.end }}</span>
                                                    <span class="data-value">—</span>
                                                </td>
                                                <td class="has-text-right">
                                                    <toggle-button
                                                        v-if="! isPastSlot(slot)"
                                                        @change="toggle(slot.key)"
                                                        :value="isTimeSlotActive(slot.key)"
                                                        :disabled="! doctor.isCertified || _.has(officeReservedAvailabilities, slot.key)"
                                                        :width="40"
                                                        :sync="true"
                                                        ></toggle-button>
                                                </td>
                                            </tr>
                                            <tr v-if="! showLateSlots">
                                                <td colspan="2" class="has-text-centered clickable" @click.prevent="toggleLateSlots()">
                                                    <a href="#" class="is-size-7">{{ $t('show_late_slots') }}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <emergency-modal
            :active="showEmergencyModal"
            v-if="Object.keys(currentEmergency).length > 0"
            @close="closeEmergencyModal()"
            :emergency="currentEmergency"
            :availability="currentAvailability">
        </emergency-modal>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import { store } from '@/store'
import moment from 'moment'

import AppSidebar from '@/components/Doctor/AppSidebar.vue'
import EmergencyModal from '@/components/Doctor/EmergencyModal.vue'
import Onboarding from '@/components/Doctor/Onboarding.vue'

import timeSlotRepository from '@/data/TimeSlotRepository'
import appointmentRepository from '@/data/AppointmentRepository'
import appointmentInvitationRepository from '@/data/AppointmentInvitationRepository'
import emergencyRepository from '@/data/EmergencyRepository'

export default {
    name: 'availabilities',

    components: { AppSidebar, EmergencyModal, Onboarding },

    mixins: [helpers],

    data () {
        return {
            timeSlots: {},
            officeReservedAvailabilities: {},
            officeAvailabilities: {},
            officeAppointments: {},
            officeAppointmentInvitations: {},
            dates: [],
            showEmergencyModal: false,
            currentAvailability: {},
            currentEmergency: {},
            showEarlySlots: false,
            showLateSlots: false
        }
    },

    mounted () {
        this.setupDates()
        this.setupTimeSlots()

        if (this.doctor && this.doctor.isCertified) {
            this.refresh()
        }
    },

    methods: {
        refresh() {
            this.refreshOfficeAppointments()
            this.refreshOfficeAvailabilities()
        },

        setupDates() {
            let futureDays = 4

            for (var i = 0; i < futureDays; i++) {
                var date = moment().add(i, 'days').startOf('day').format('YYYY-MM-DD')
                this.dates.push(date)

                if (!this.currentDate && i == 0) {
                    this.selectDate(date)
                }
            }
        },

        selectDate (date) {
            this.showEarlySlots = false
            this.showLateSlots = false
            this.setCurrentDate(date)
        },

        isTimeSlotActive(time) {
            return _.has(this.officeAvailabilities, time) || _.has(this.officeReservedAvailabilities, time);
        },

        toggleEarlySlots() {
            this.showEarlySlots = ! this.showEarlySlots
        },

        toggleLateSlots() {
            this.showLateSlots = ! this.showLateSlots
        },

        toggle (time) {
            if (! this.doctor.isCertified) {
                this.alertError(this.$t('doctor_not_certified_warning'))
                return false
            }

            // this.setLoading(true)

            if (this.isTimeSlotActive(time)) {
                this.deactivateTimeSlot(time);
            } else {
                this.activateTimeSlot(time);
            }
        },

        activateTimeSlot (time) {
            timeSlotRepository.create(this.doctor, this.offices[this.currentOffice], this.currentDate, time, (timeSlot) => {
                // Add the timeSlot to the office availabilities
                this.officeAvailabilities[time] = timeSlot
            }, (error) => {
                this.alertError(error.message)

                this.refresh()
            })
        },

        deactivateTimeSlot (time) {
            timeSlotRepository.delete(this.doctor, this.offices[this.currentOffice], this.currentDate, time, (timeSlot) => {
                // Remove the timeSlot from the office availabilities
                delete this.officeAvailabilities[time]
            }, (error) => {
                this.alertError(error.message)

                this.refresh()
            })
        },

        refreshOfficeAppointments () {
            if (! this.doctor) {
                return false
            }

            // Load Appointments & Invitations
            this.setLoading(true)

            appointmentInvitationRepository.allForOfficeDate(this.doctor.id, this.currentOffice, this.currentDate, (appointmentInvitations) => {
                this.officeAppointmentInvitations = {}

                _.forEach(appointmentInvitations, (appointmentInvitation) => {
                    this.officeAppointmentInvitations[appointmentInvitation.id] = appointmentInvitation
                })

                this.setLoading(false)
            }, () => {
                this.alertError(this.$t('appointment_invitations_could_not_be_loaded'))

                this.setLoading(false)
            })

            appointmentRepository.allForOfficeDate(this.doctor.id, this.currentOffice, this.currentDate, (appointments) => {
                this.officeAppointments = {}

                _.forEach(appointments, (appointment) => {
                    this.officeAppointments[appointment.id] = appointment
                })

                this.setLoading(false)
            }, () => {
                this.alertError(this.$t('appointments_could_not_be_loaded'))

                this.setLoading(false)
            })
        },

        refreshOfficeAvailabilities () {
            if (! this.doctor) {
                return false
            }

            this.setLoading(true)

            timeSlotRepository.allForDate(this.doctor.id, this.currentOffice, this.currentDate, (timeSlots) => {
                this.officeAvailabilities = {}
                this.officeReservedAvailabilities = {}

                _.forEach(timeSlots, (timeSlot) => {
                    var start = moment.duration(timeSlot.time * 15, 'minutes')
                    var end = start.clone().add(15, 'minutes')

                    var officeTimeSlot = Object.assign(timeSlot, {
                        start: moment.utc(start.asMilliseconds()).format(this.$t('time_format')),
                        end: moment.utc(end.asMilliseconds()).format(this.$t('time_format'))
                    })

                    if (timeSlot.appointmentId || timeSlot.appointmentInvitationId) {
                        this.officeReservedAvailabilities[timeSlot.time] = officeTimeSlot
                    } else {
                        this.officeAvailabilities[timeSlot.time] = officeTimeSlot
                    }
                })

                this.setLoading(false)
            }, () => {
                this.alertError(this.$t('timeslots_could_not_be_loaded'))

                this.setLoading(false)
            })
        },

        setupTimeSlots () {
            for (let i = 0; i < 96; i++) {
                var start = moment.duration(i * 15, 'minutes')
                var end = start.clone().add(15, 'minutes')
                this.timeSlots[i] = {
                    key: i,
                    start: moment.utc(start.asMilliseconds()).format(this.$t('time_format')),
                    end: moment.utc(end.asMilliseconds()).format(this.$t('time_format'))
                }
            }
        },

        cancelInvitation (invitationId) {
            this.setLoading(true)

            var appointmentInvitation = this.officeAppointmentInvitations[invitationId]

            appointmentInvitationRepository.cancel(appointmentInvitation, () => {
                this.refresh()
            }, (error) => {
                this.setLoading(false)
                this.alertError(error.message)
            })
        },

        getAvailabilityByTime(time) {
            return this.officeReservedAvailabilities[time]
        },

        getAppointmentByAvailability(availability) {
            var appointment = {}

            if (availability.appointmentId) {
                appointment = this.officeAppointments[availability.appointmentId]
            } else if (availability.appointmentInvitationId) {
                appointment = this.officeAppointmentInvitations[availability.appointmentInvitationId]
            }

            return appointment
        },

        hasAvailabilityPictures (time) {
            var availability = this.getAvailabilityByTime(time)
            var appointment = this.getAppointmentByAvailability(availability)

            return appointment && appointment.emergencyPictures.length > 0
        },

        getAvailabilityPicture (time) {
            var availability = this.getAvailabilityByTime(time)
            var appointment = this.getAppointmentByAvailability(availability)

            return appointment.emergencyPictures[0]
        },

        getAvailabilityStatus (time) {
            var availability = this.getAvailabilityByTime(time)
            var appointment = this.getAppointmentByAvailability(availability)

            if (availability.appointmentId) {
                appointment = this.officeAppointments[availability.appointmentId]

                return "(" + this.$t('status_confirmed_label') + ")"
            } else if (availability.appointmentInvitationId) {
                appointment = this.officeAppointmentInvitations[availability.appointmentInvitationId]

                if (appointment) {
                    if (appointment.hasBeenCancelled || appointment.hasBeenAutoCancelled) {
                        return "(" + this.$t('status_cancelled_label') + ")"
                    }

                    if (appointment.hasBeenDeclined) {
                        return "(" + this.$t('status_declined_label') + ")"
                    }
                }

                return "(" + this.$t('status_pending_label') + ")"
            }

            return ""
        },

        getPatientInfo (time) {
            var availability = this.getAvailabilityByTime(time)
            var appointment = this.getAppointmentByAvailability(availability)

            if (appointment && Object.keys(appointment).length) {
                return this.hashPatientInfo(appointment.patientFirstName) + ' ' + this.hashPatientInfo(appointment.patientLastName) + ' (' + appointment.patientAge + ')'
            }

            return "N/A"
        },

        closeEmergencyModal() {
            this.showEmergencyModal = false
            this.currentEmergency = {}
            this.currentAvailability = {}
            document.documentElement.classList.toggle('is-clipped', false)
        },

        showEmergency(time) {
            this.setLoading(true)
            var availability = this.getAvailabilityByTime(time)
            var appointment = this.getAppointmentByAvailability(availability)

            var emergencyId = appointment.emergencyId

            emergencyRepository.find(emergencyId, (emergency) => {
                this.currentAvailability = availability
                this.currentEmergency = emergency
                this.showEmergencyModal = true

                this.setLoading(false)
            }, (error) => {
                this.alertError(error.message)

                this.setLoading(false)
            })
        },

        isPastSlot (slot) {
            if (this.currentDate > moment().format('YYYY-MM-DD')) {
                return false
            }

            return slot.start < moment().format('HH:mm');
        }
    },

    watch: {
        currentOffice (newCurrentOffice) {
            this.refresh()
        },

        currentDate (newCurrentOffice) {
            this.refresh()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Availabilities.vue